<!-- <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="dialogRef.close(false)">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button> -->

<h1 mat-dialog-title class="text-center blueHeader dialogHeader text-white">{{headerTitle}}</h1>
<mat-dialog-content class="mb-4">
  <div class="mt-3" *ngIf="!batchFlag">
    <div class="col-md-12 mb-2">
      <label for="name" class="payingClinic col-md-6 required">Name</label>
      <input type="text" class="form-control input-font name inputBox col-md-6" id="name" [(ngModel)]="name">
    </div>
    <div class="col-md-12 mb-2">
      <label for="category" class="toPay col-md-6 required">Category</label>
      <select name="category" id="category" class="form-control input-font category inputBox col-md-6" [disabled]="true"
        [(ngModel)]="category">
        <option value="TABLET">Tablet</option>
        <option value="SYRUP-SUPPLEMENT">Syrup</option>
        <option value="VACCINATION-DEWORMING">Vaccination / Deworming</option>
        <option value="DISPOSABLE">Disposables</option>
        <option value="DROPS">Drops</option>
        <option value="INJECTABLE">Injectables</option>
        <option value="POWDER-SHAMPOO">Powder / Shampoo</option>
        <option value="OINTMENT-SPRAY">Ointment / Spray</option>
        <option value="PRODUCT">Consumables</option>
        <option value="SERVICES">Others</option>
      </select>
    </div>
    <div class="col-md-12 mb-2">
      <label for="manuf" class="toPay col-md-6 required">Manufacturer</label>
      <input type="text" class="form-control input-font price inputBox col-md-6" id="manuf" [(ngModel)]="manuf">
    </div>
    <div class="col-md-12 mb-2">
      <label for="instrc" class="toPay col-md-6 required">Instructions</label>
      <input type="text" class="form-control input-font qty inputBox col-md-6" id="instrc" [(ngModel)]="instrc">
    </div>
    <div class="col-md-12 mb-2">
      <label for="seller_name" class="toPay col-md-6 required">Seller Name</label>
      <input type="text" class="form-control input-font price inputBox col-md-6" id="seller_name"
        [(ngModel)]="seller_name">
    </div>
  </div>
  <div *ngIf="batchFlag">
    <div class="col-md-12 mb-2">
      <label for="name" class="payingClinic col-md-5 required">Name</label>
      <input type="text" class="form-control input-font name inputBox col-md-7" id="name" [(ngModel)]="name"
        [disabled]="true">
    </div>
    <div class="col-md-12 mb-2">
      <label for="price" class="toPay col-md-5 required">Price</label>
      <input type="number" class="form-control input-font price inputBox col-md-7" id="price" [(ngModel)]="price">
    </div>
    <div class="col-md-12 mb-2">
      <label for="rack_no" class="toPay col-md-5 required">Rack No</label>
      <input type="text" class="form-control input-font price inputBox col-md-7" id="rack_no" [(ngModel)]="rack_no">
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="offset-md-2">
    <button mat-button class="mat-raised-button mr-4 btn blankTurquoise btnWidth"
      (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button class="mat-raised-button btn turquoiseBtn btnWidth btn-sm updateButton"
      (click)="updateBatchItem()" *ngIf="batchFlag">Update</button>
    <button mat-button class="mat-raised-button btn turquoiseBtn btnWidth btn-sm updateButton" (click)="updateItem()"
      *ngIf="!batchFlag">Update</button>
  </div>
</mat-dialog-actions>
